<template>
  <div class="custom-select">
    <VueSelect
      :id="identifier"
      v-model="value"
      :clearable="false"
      :components="{ OpenIndicator }"
      :filterable="false"
      :options="options"
      :searchable="false"
      @input="$emit('change', $event.code)">
      <template
        slot="option"
        slot-scope="option">
        <div
          class="custom-select__option"
          :style="textCenter">
          {{ option.label }}
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <div
          class="custom-select__option"
          :style="textCenter">
          {{ option.label }}
        </div>
      </template>
    </VueSelect>
  </div>
</template>

<script>
  import VueSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  export default {
    components: { VueSelect },
    data() {
      return {
        OpenIndicator: {
          render: createElement => createElement(`span`, { class: `custom-select__icon` }),
        },
        value: null,
      };
    },
    computed: {
      textCenter() {
        if(this.centerTextAlign) {
          return { textAlign: `center`, width: `100%` };
        }
        return null;
      },
    },
    props: {
      centerTextAlign: {
        default: false,
        type: Boolean,
      },
      identifier: {
        default: ``,
        type: String,
      },
      options: {
        required: true,
        type: Array,
      },
      selected: {
        default: null,
        type: Number,
      },
    },
    methods: {
      setValue() {
        this.value = this.options[this.options.findIndex(option => option.code === this.selected)];
      },
    },
    watch: {
      options: {
        handler() {
          if(this.selected) {
            this.setValue();
          } else {
            [this.value] = this.options;
          }
        },
        immediate: true,
      },
      selected: {
        handler() {
          this.setValue();
        },
      },
    },
  };
</script>

<style lang="less">
  // non scoped style for vue-select overrides specific to this component
  @import '../../../assets/styles/rin-variables';

  .custom-select {
    background: @colorWhite;
    display: inline-block;
    margin-bottom: 15px;
    width: 100%;

    &__icon {
      background-image: url('/wp-content/themes/JointsWP/assets/images/arrow-down.svg') !important;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 15px;
      height: 15px;
      padding-right: 27px;
      width: 15px;
    }

    &__option {
      margin: 0;
      overflow: hidden;
      padding: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: auto;
    }

    .vs {
      &__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      &__dropdown-menu {
        border: 1px solid @colorBlack;
        border-radius: 0;
        margin: 0;
        max-height: unset;
        min-width: 100%;
        overflow: auto;
        padding: 0;
        width: auto;
      }

      &__dropdown-option {
        background: @colorWhite;
        margin: 0;
        padding: 7px;
        text-transform: uppercase;
        white-space: unset;

        &--highlight {
          background: #fff;
          border: 1px solid @colorBlack;
          color: @colorBlack;
        }
      }

      &__dropdown-toggle {
        border: 1px solid @colorBlack;
        border-radius: 0;
        height: 40px;
        position: relative;
      }

      &__search {
        // place the input above the whole field to preserve the keyboard and focus functionality
        &[readonly] {
          background-color: transparent;
          border: 0;
          left: 0;
          margin: 0;
          padding: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }
      }

      &__selected {
        width: 100%;
      }

      &__selected-options {
        flex-grow: 0;
        padding-right: 30px;
        text-transform: uppercase;
        width: 100%;
      }
    }

    // reset the positioning of the selected entry when the dropdown is opened
    .vs--single.vs--open .vs__selected { position: relative; }
  }
</style>
